const s = {
  name: "Hands111112",
  dimensions: { width: 26, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 26 40" style="enable-background:new 0 0 26 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M0,6c0-2.2,1.8-4,4-4c0.8,0,1.6,0.2,2.2,0.7C6.8,1.1,8.3,0,10,0c1.7,0,3.2,1.1,3.8,2.7C14.4,2.2,15.2,2,16,2
			c2.2,0,4,1.8,4,4v0.6C20.6,6.2,21.3,6,22,6c2.3,0,4,2.1,4,4.4V27c0,7.2-5.8,13-13,13C5.8,40,0,34.2,0,27V6z M10,2C8.9,2,8,2.9,8,4
			v17h4V4C12,2.9,11.1,2,10,2z M14,21h4V6c0-1.1-0.9-2-2-2s-2,0.9-2,2V21z M20,21h2v2H8v2H6v-9c0-1.1-0.9-2-2-2c-1.1,0-2,0.9-2,2v11
			c0,6.1,4.9,11,11,11s11-4.9,11-11V10.4C24,9,23,8,22,8c-1,0-2,1-2,2.4V21z M6,6c0-1.1-0.9-2-2-2C2.9,4,2,4.9,2,6v6.5
			C2.6,12.2,3.3,12,4,12s1.4,0.2,2,0.5V6z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Hands111112
};
